module.exports = __webpack_public_path__ + "img/FICon.34a9bae9.jpg";